// Returns the next week's Monday 00:00 and Sunday 23:59:59 dates
export function getNextWeekMondayRange(baseDate = new Date()) {
  const d = new Date(baseDate);
  const day = d.getDay(); // 0=Sun,..6=Sat
  const daysUntilNextMonday = ((8 - day) % 7) || 7; // ensure at least 1 week ahead
  const monday = new Date(d);
  monday.setDate(d.getDate() + daysUntilNextMonday);
  monday.setHours(0, 0, 0, 0);

  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);
  sunday.setHours(23, 59, 59, 999);

  return { start: monday, end: sunday };
}

export function toYmd(date) {
  const d = new Date(date);
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function clampRangeToMaxDays(start, end, maxDays) {
  const s = new Date(start);
  const e = new Date(end);
  const msMax = maxDays * 24 * 60 * 60 * 1000;
  if (e.getTime() - s.getTime() > msMax) {
    const clamped = new Date(s.getTime() + msMax - 1);
    return { start: s, end: clamped };
  }
  return { start: s, end: e };
}

